import { render } from "./AddUsers.vue?vue&type=template&id=b5fd20a8&scoped=true"
import script from "./AddUsers.vue?vue&type=script&lang=js"
export * from "./AddUsers.vue?vue&type=script&lang=js"

import "./AddUsers.vue?vue&type=style&index=0&id=b5fd20a8&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5fd20a8"]])

export default __exports__